import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { WartungsvertragPamentMethodSource } from '../Enums/WartungsvertragPamentMethodSource.enum';

export class BatchBillingServiceContractsSettings<
  T extends EMode = EMode.entity
> {
  /** Alias: batchBillingRunName */
  batchBillingRunName?: string;
  /** Alias: headerShowBatchBillingRunName */
  headerShowBatchBillingRunName?: boolean;
  /** Alias: headerShowObjectName */
  headerShowObjectName?: boolean;
  /** Alias: headerShowPeriod */
  headerShowPeriod?: boolean;
  /** Alias: headerShowContractNumber */
  headerShowContractNumber?: boolean;
  /** Alias: internalNoteShowBatchBillingRunName */
  internalNoteShowBatchBillingRunName?: boolean;
  /** Alias: internalNoteShowObjectName */
  internalNoteShowObjectName?: boolean;
  /** Alias: internalNoteShowPeriod */
  internalNoteShowPeriod?: boolean;
  /** Alias: internalNoteShowContractNumber */
  internalNoteShowContractNumber?: boolean;
  /** Alias: useDefaultTextFromCustomer */
  useDefaultTextFromCustomer?: boolean;
  /** Alias: paymentTypeSource */
  paymentTypeSource?: WartungsvertragPamentMethodSource;
  /** Alias: setNewBillingDate */
  setNewBillingDate?: boolean;
  /** Alias: considerQuantity */
  considerQuantity?: boolean;
  /** Alias: dividePriceByQuantity */
  dividePriceByQuantity?: boolean;
  /** Alias: divideByRhythm */
  divideByRhythm?: boolean;
  /** Alias: multiplyWithRhythm */
  multiplyWithRhythm?: boolean;
  /** Alias: purchasePriceFromArticle */
  purchasePriceFromArticle?: boolean;
  /** Alias: headerShowContractTypeAlias */
  headerShowContractTypeAlias?: boolean;
  /** Alias: internalNoteShowContractTypeAlias */
  internalNoteShowContractTypeAlias?: boolean;

  __typename?: string;
}

const fields: FieldDefinitions<BatchBillingServiceContractsSettings> = {
  batchBillingRunName: {
    alias: 'batchBillingRunName',
  },
  headerShowBatchBillingRunName: {
    alias: 'headerShowBatchBillingRunName',
  },
  headerShowObjectName: {
    alias: 'headerShowObjectName',
  },
  headerShowPeriod: {
    alias: 'headerShowPeriod',
  },
  headerShowContractNumber: {
    alias: 'headerShowContractNumber',
  },
  internalNoteShowBatchBillingRunName: {
    alias: 'internalNoteShowBatchBillingRunName',
  },
  internalNoteShowObjectName: {
    alias: 'internalNoteShowObjectName',
  },
  internalNoteShowPeriod: {
    alias: 'internalNoteShowPeriod',
  },
  internalNoteShowContractNumber: {
    alias: 'internalNoteShowContractNumber',
  },
  useDefaultTextFromCustomer: {
    alias: 'useDefaultTextFromCustomer',
  },
  paymentTypeSource: {
    alias: 'paymentTypeSource',
  },
  setNewBillingDate: {
    alias: 'setNewBillingDate',
  },
  considerQuantity: {
    alias: 'considerQuantity',
  },
  dividePriceByQuantity: {
    alias: 'dividePriceByQuantity',
  },
  divideByRhythm: {
    alias: 'divideByRhythm',
  },
  multiplyWithRhythm: {
    alias: 'multiplyWithRhythm',
  },
  purchasePriceFromArticle: {
    alias: 'purchasePriceFromArticle',
  },
  headerShowContractTypeAlias: {
    alias: 'headerShowContractTypeAlias',
  },
  internalNoteShowContractTypeAlias: {
    alias: 'internalNoteShowContractTypeAlias',
  },
  __typename: {
    alias: '__typename',
  },
};

export const batchBillingServiceContractsSettingsEntityDefinition: EntitiyDefinition<BatchBillingServiceContractsSettings> =
  {
    local: {},
    remote: {
      queryName: 'getBatchBillingServiceContractsSettings',
      fragmentName: 'BatchBillingServiceContractsSettings',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'upsertBatchBillingServiceContractsSettings',
          args: [
            {
              name: 'settings',
              type: 'InputBatchBillingServiceContractsSettings!',
            },
          ],
        },
      },
    },
    fieldDefinitions: fields,
  };
